import { lazy } from 'react';

const RELOAD_KEY = 'advicelink:chunk-reload-at';
const RELOAD_WINDOW_MS = 60 * 1000;

function isChunkLoadError(error) {
  const text = `${error?.name || ''} ${error?.message || ''}`;
  return /ChunkLoadError|Loading chunk [\w-]+ failed|Loading CSS chunk|Failed to fetch dynamically imported module|Importing a module script failed/i.test(text);
}

/**
 * React.lazy for a page, so its code downloads only when the page opens (the
 * first load on a phone no longer waits for every page in the app).
 *
 * Firebase Hosting serves only the latest deploy, so a tab left open across a
 * deploy asks for chunk files that no longer exist. That ChunkLoadError
 * reloads the page once (guarded so a real outage cannot loop).
 */
export function lazyPage(importer) {
  return lazy(() => importer().catch((error) => {
    if (typeof window !== 'undefined' && isChunkLoadError(error)) {
      let last = 0;
      try { last = Number(window.sessionStorage.getItem(RELOAD_KEY)) || 0; } catch { /* storage blocked */ }
      if (Date.now() - last > RELOAD_WINDOW_MS) {
        try { window.sessionStorage.setItem(RELOAD_KEY, String(Date.now())); } catch { /* storage blocked */ }
        window.location.reload();
        return new Promise(() => {}); // keep Suspense showing while the page reloads
      }
    }
    throw error;
  }));
}

export { isChunkLoadError };
export default lazyPage;
